import React from 'react';
import { Text } from '@oneaudi/unified-web-components';

import { VehicleBasic } from '@oneaudi/vtp-shared';
import {
  NavBackWrapper,
  NavigationContainer,
  VehicleDetailWrapper,
} from '../../styles/ConversionBar.styles';
import { Backlink } from './Backlink';

interface NavigationWrapperProps {
  vehicle: VehicleBasic;
  isColumn: boolean;
}

export const NavigationWrapper: React.FC<NavigationWrapperProps> = ({ vehicle, isColumn }) => {
  return (
    <NavigationContainer data-testid="conversion-navigation">
      <NavBackWrapper isColumn={isColumn}>
        <Backlink />
      </NavBackWrapper>
      <VehicleDetailWrapper>
        <Text
          tag="span"
          variant={{ type: 'copy', order: '1', style: 'bold' }}
          data-testid="vehicle-name"
        >
          {vehicle.symbolicCarline.description}
        </Text>
        <Text
          tag="span"
          variant={{ type: 'copy', order: '2', style: 'normal' }}
          data-testid="vehicle-description"
        >
          {vehicle.modelCode.description}
        </Text>
      </VehicleDetailWrapper>
    </NavigationContainer>
  );
};
